import React from 'react';
import { Icon, Link, globals } from 'common-ui';
import { handleMiniCartClickEvents, handleRedirectionClick } from '../../../../utils/cart/miniCartUtils';

type GiftMessageProps = {
  className: string;
  redirectLink: string;
  onClose: () => void;
};

const GiftMessage: React.FC<GiftMessageProps> = ({ className, redirectLink, onClose }) => {
  const viewCartText = globals?.country === 'uk' ? 'basket' : 'cart';
  const message = `You ${globals?.country === 'us' ? 'qualify for' : 'got'} a free gift`;

  return (
    <div className={className}>
      <Icon kind="gift" size="s" />
      <h4>
        <span>{message}</span>
        <Link
          href={redirectLink}
          className="cart-link light-grey"
          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            handleRedirectionClick(e, redirectLink, onClose);
            handleMiniCartClickEvents('viewInCarttMiniCartClick');
          }}
        >
          {`View in ${viewCartText}`}
        </Link>
      </h4>
    </div>
  );
};

export default GiftMessage;
